import React from 'react';
import { useTranslation } from 'react-i18next';
import { CopyOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { toast } from 'react-toastify';
import classnames from 'classnames';

// Enter and Space press a button; the rest of the keyboard is the page's.
const PRESS_KEYS = ['Enter', ' ', 'Spacebar'];

export default function ClickToCopy({ value, noIcon, children, textClassName, containerClassName }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:ClickToCopy' });

  const copy = () => {
    navigator.clipboard.writeText(value ?? children);

    toast.success(t('success'));
  };

  // Still a span, so it looks the same wherever it sits — inside a sentence, a table cell,
  // a menu row. The role, the tab stop and Enter/Space make it a button for a keyboard and
  // a screen reader too; Space would otherwise scroll the page.
  const onKeyDown = (event) => {
    if (PRESS_KEYS.includes(event.key)) {
      event.preventDefault();
      copy();
    }
  };

  return (
    <Tooltip title={t('tooltip_title')} className={textClassName}>
      <span
        role="button"
        tabIndex={0}
        onClick={copy}
        onKeyDown={onKeyDown}
        className={classnames('cursor-pointer my-auto', containerClassName)}
      >
        {!noIcon && <CopyOutlined className="text-brand-text-default text-base" />} {children}
      </span>
    </Tooltip>
  );
}
